<template>
  <div>
    <template v-if="contact.greeting">
      {{ contact.greeting }}
    </template>
    <v-chip v-else
            color="orange lighten-4"
            text-color="orange darken-4"
            label
            small
            class="d-block text-center font-weight-bold">
      Missing
    </v-chip>
  </div>
</template>
<script>
export default {
  props: {
    contact: {
      type: Object,
      required: true,
    }
  },
}
</script>
